import { render, staticRenderFns } from "./modal-add-edit-litter-notes.vue?vue&type=template&id=2a183f3f&scoped=true&lang=pug"
import script from "./modal-add-edit-litter-notes.js?vue&type=script&lang=js&external"
export * from "./modal-add-edit-litter-notes.js?vue&type=script&lang=js&external"
import style0 from "./modal-add-edit-litter-notes.vue?vue&type=style&index=0&id=2a183f3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a183f3f",
  null
  
)

export default component.exports